import { render, staticRenderFns } from "./KkmSearchForm.vue?vue&type=template&id=070476cc&"
import script from "./KkmSearchForm.vue?vue&type=script&lang=js&"
export * from "./KkmSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports